import { render, staticRenderFns } from "./QuestionTstatSelect.vue?vue&type=template&id=7bf8ec1a&scoped=true&"
import script from "./QuestionTstatSelect.vue?vue&type=script&lang=js&"
export * from "./QuestionTstatSelect.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTstatSelect.vue?vue&type=style&index=0&id=7bf8ec1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8ec1a",
  null
  
)

export default component.exports